/* ----------------------------------------------------------------------------
   GB-MODAL — delegierte Oeffnen/Schliessen-Logik fuer alle .gb-overlay-Dialoge
   ----------------------------------------------------------------------------
   Am 19.08.2026 aus snippets/product-info.liquid hierher gezogen. Dort lag das
   Script inline INNERHALB von product-rerender. Dieses Custom Element ersetzt
   bei Variantenwechsel sein innerHTML — per innerHTML eingefuegte Script-Tags
   fuehrt der Browser NICHT aus. Auf Produkten ohne Groessenberater-Inhalt lief
   der Handler dadurch nie: window.__gbDelegated blieb false, jedes Modal blieb
   beim Klick geschlossen. Gemessen an der keramischen Kupferkernpfanne.
   Als Asset mit defer laeuft es genau einmal, unabhaengig von Renderdurchlaeufen.
   ---------------------------------------------------------------------------- */

/* Olavson (2026-07-08): Event-Delegation statt Direct-Bind.
   Impact re-rendert bei variant:change das ganze .product-info-DOM.
   Ein Direct-addEventListener auf dem Trigger-Button ist danach am
   detached-Element haengengeblieben; inline <script>-Tags werden
   nach innerHTML-Replace NICHT re-executed. Loesung: Delegation
   auf document — der Handler lebt persistent, matched per closest()
   gegen aria-controls, gb-close und den overlay-Backdrop. */
(function() {
  if (window.__gbDelegated) return;
  window.__gbDelegated = true;

  function trackOpener(overlay, btn) {
    overlay.__gbOpener = btn;
  }
  function releaseSticky(overlay) {
    var stickyCol = overlay.closest('safe-sticky');
    if (stickyCol) stickyCol.style.zIndex = '';
  }
  function raiseSticky(overlay) {
    var stickyCol = overlay.closest('safe-sticky');
    if (stickyCol) stickyCol.style.zIndex = '9999';
  }
  function openOverlay(overlay, opener) {
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    raiseSticky(overlay);
    if (opener) trackOpener(overlay, opener);
    var closeBtn = overlay.querySelector('.gb-close');
    if (closeBtn) closeBtn.focus();
  }
  function closeOverlay(overlay) {
    overlay.hidden = true;
    document.body.style.overflow = '';
    releaseSticky(overlay);
    var opener = overlay.__gbOpener;
    if (opener && document.body.contains(opener)) opener.focus();
  }

  document.addEventListener('click', function(e) {
    /* Open: any button/link with aria-controls="gb-modal-…" */
    var opener = e.target.closest('[aria-controls]');
    if (opener) {
      var id = opener.getAttribute('aria-controls') || '';
      if (id.indexOf('gb-modal-') === 0) {
        var overlay = document.getElementById(id);
        if (overlay) {
          openOverlay(overlay, opener);
          return;
        }
      }
    }
    /* Close via X-Button */
    var closeBtn = e.target.closest('.gb-close');
    if (closeBtn) {
      var overlay2 = closeBtn.closest('.gb-overlay');
      if (overlay2) closeOverlay(overlay2);
      return;
    }
    /* Backdrop-Klick (nur wenn direkt auf .gb-overlay) */
    if (e.target.classList && e.target.classList.contains('gb-overlay')) {
      closeOverlay(e.target);
    }
  });

  /* Olavson (2026-08-19): Aufraeumen beim Re-Render.
     product-rerender ersetzt bei jedem Variantenwechsel das innerHTML der
     Produktspalte. Ein offenes Overlay verschwindet dabei aus dem DOM, ohne
     dass closeOverlay() je gelaufen waere — body { overflow: hidden } blieb
     stehen, die Produktseite war danach ohne sichtbare Ursache nicht mehr
     scrollbar. Betraf Groessenberater und Vergleichstabellen-Popup gleich.

     product:rerender ist der passende Aufhaenger: Es wird bei JEDEM Wechsel
     gefeuert, auch beim Sprung auf ein anderes Produkt (variant:change laeuft
     nur, wenn das Produkt dasselbe bleibt). Es bubbelt nicht — der Dispatch
     auf dem Form setzt kein bubbles: true —, in der Capture-Phase auf document
     ist es aber erreichbar. Capture laeuft VOR dem Listener des
     product-rerender-Elements, das alte DOM steht also noch: closeOverlay()
     nimmt Sticky-z-index und Fokus regulaer zurueck, statt nur das
     Style-Attribut zu putzen.

     Der Abgleich danach ist die Rueckfallebene fuer jeden anderen Weg, auf dem
     ein Overlay aus dem DOM verschwindet: Existiert kein offenes .gb-overlay
     mehr, faellt die Sperre. Kein zusaetzlicher Zustand — das DOM ist die
     Quelle der Wahrheit. */
  document.addEventListener('product:rerender', function() {
    var open = document.querySelectorAll('.gb-overlay:not([hidden])');
    for (var i = 0; i < open.length; i++) closeOverlay(open[i]);
    requestAnimationFrame(function() {
      if (!document.querySelector('.gb-overlay:not([hidden])')) {
        document.body.style.overflow = '';
      }
    });
  }, true);

  document.addEventListener('keydown', function(e) {
    var overlays = document.querySelectorAll('.gb-overlay:not([hidden])');
    if (!overlays.length) return;
    var overlay = overlays[overlays.length - 1];
    if (e.key === 'Escape') { closeOverlay(overlay); return; }
    if (e.key !== 'Tab') return;
    var modal = overlay.querySelector('.gb-modal');
    if (!modal) return;
    var focusable = Array.prototype.slice.call(
      modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  });
})();
